import { Button, Col, Container, Row } from 'react-bootstrap'

import styles from './ContentFullScreen2.module.scss'

export type ContentFullScreen2Props = {
    halfTitle?: string
    title?: string
    bgImage: string
    desc?: string
    customClass?: string
    linkButton?: { label: string; link: string; variant: string }
    children?: React.ReactNode
}

export default function ContentFullScreen2({
    halfTitle,
    title,
    desc,
    linkButton,
    customClass,
    bgImage,
    children,
}: ContentFullScreen2Props) {
    const componentClass = `ContentFullScreen2 ${styles.ContentFullScreen2} ${customClass ?? ''}`

    return (
        <section style={{ backgroundImage: `url("${bgImage}")` }} className={componentClass}>
            <div>
                <Container>
                    <Row className="align-items-center ">
                        <Col lg={6}>
                            {halfTitle && <p className="half-title">A blockchain for the “other” 25M developers</p>}
                            <h2 className="section-title-h2 mb-4">{title}</h2>
                            {desc && <p>{desc}</p>}
                            {linkButton && (
                                <Button href={linkButton.link} variant={linkButton.variant}>
                                    {linkButton.label}
                                </Button>
                            )}
                            {children}
                        </Col>
                        <Col lg={6}></Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}
